import { render } from "./PortfolioMainView.vue?vue&type=template&id=0ae3b47a"
import script from "./PortfolioMainView.vue?vue&type=script&lang=js"
export * from "./PortfolioMainView.vue?vue&type=script&lang=js"

import "./PortfolioMainView.vue?vue&type=style&index=0&id=0ae3b47a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__